import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import {
  Row,
  Col,
  DatePicker,
  Table,
  Tag,
  Progress,
  Avatar,
  Button,
  Input,
  InputNumber,
  Dropdown,
  Menu,
  Select,
  Form,
  Tooltip,
  Modal,
  notification,
} from 'antd';
import { CaretDownOutlined, CaretUpOutlined, EditOutlined } from '@ant-design/icons';
import { submitProject, updateProject, fetchProject } from '../../redux/actions/projectAction';
import { BASE_URL } from '../../config.js';
import fetch from '../../services/fetch';
import moment from 'moment';
import CreateProject from '../../components/createProject';
import { NDT_PIPELINE_TYPE_OPTIONS } from '../../constants/ndtPipelineTypeOptions';
import { ndtTypeFormInitial, normalizeNdtTypeForApi } from '../../utils/sowNdtStation';
import ModernMultiCheckboxSelect from '../../components/common/ModernMultiCheckboxSelect';
// import "./ProjectsDashboard.scss";
const { Option } = Select;
const { Search } = Input;
const data = [
  {
    clientId: '1',
    projectName: 'Southwest Airlines',
    location: 'Southwest Airlines Co.',
    projectStatus: '1',
    manager: 'A Need For Upgrades',
    startDate: 'Local School Receives New Grant',
    endDate: 'xyz',
    members: ['A', 'B', 'C'],
    progress: 100,
  },
];

const statusColors = {
  Completed: 'green',
  Active: 'orange',
  OnHold: 'blue',
  Initiated: 'geekblue',
  Facility: 'pink',
};

/** Heat-style facet columns (dataIndex paths on enriched rows) */
const PROJECT_FACET_KEYS = [
  'projectName',
  'statusLabel',
  'location',
  'projectType',
  'projectId',
  'clientName',
  'manager',
  'startDate',
  'endDate',
];

const PROJECT_COLUMN_FILTERS_EMPTY = {
  projectName: '',
  statusLabel: '',
  location: '',
  projectType: '',
  projectId: '',
  clientName: '',
  manager: '',
  startDate: '',
  endDate: '',
};

/** API may return project.config as object or JSON string */
const parseProjectConfig = (config) => {
  if (config == null) return {};
  if (typeof config === 'string') {
    const t = config.trim();
    if (!t) return {};
    try {
      const p = JSON.parse(t);
      return p && typeof p === 'object' && !Array.isArray(p) ? p : {};
    } catch {
      return {};
    }
  }
  if (typeof config === 'object' && !Array.isArray(config)) return { ...config };
  return {};
};

const getStatusString = (status) => {
  switch (status) {
    case 1:
      return 'Initiated';
    case 2:
      return 'Active';
    case 3:
      return 'OnHold';
    case 4:
      return 'Completed';
    case 5:
      return 'Facility';
    default:
      return 'Unknown';
  }
};

const ProjectDashboard = (props) => {
  const { onSubmitProject, onUpdateProject, reloadData } = props;
  const {
    setSelectedProj,
    selectedProject,
    projectList,
    clientList,
    setIsShowProjectData,
    onProjectClick,
  } = props;
  const [isEditStartDate, setIsEditStartDate] = useState(false);
  const [isEditEndDate, setIsEditEndDate] = useState(false);
  const [isEditprojectStatus, setIsEditprojectStatus] = useState(false);
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dayShiftHour, setDayShiftHour] = useState('');
  const [nightShiftHour, setNightShiftHour] = useState('');
  const [dayShiftInputHour, setDayShiftInputHour] = useState('');
  const [nightShiftInputHour, setNightShiftInputHour] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [masterProject, setMasterProject] = useState([]);
  const [searchText, onSearch] = useState('');
  const [text, setText] = useState('');
  const [projectId, setProjectId] = useState(0);
  const [searchNotFound, setSearchNotFound] = useState(false);
  const [isEditDefaultHourModalVisible, setIsEditDefaultHourModalVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [projectStatus, setProjectStatus] = useState('');
  const [projectForm] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editProjectType, setEditProjectType] = useState('');
  const [editNdtType, setEditNdtType] = useState(undefined);
  const [editFinalClient, setEditFinalClient] = useState('');
  const [filterStatus, setFilterStatus] = useState(2);
  const [completedProject, setCompletedProject] = useState(0);
  const [facilityProject, setFacilityProject] = useState(0);
  const [activeProject, setActiveProject] = useState(0);
  const [initiatedProject, setInitiatedProject] = useState(0);
  const [onHoldProject, setOnHoldProject] = useState(0);
  const [updateProjectId, setUpdateProjectId] = useState(0);
  const [columnFilters, setColumnFilters] = useState(() => ({ ...PROJECT_COLUMN_FILTERS_EMPTY }));
  const [sortKey, setSortKey] = useState('projectName');
  const [sortDesc, setSortDesc] = useState(false);
  const [projectName, setProjectName] = useState('');
  const [isGuestUser, setIsGuestUser] = useState(false);

  const userGroups = JSON.parse(localStorage.getItem('UserGroup') || '[]');
  /** Project name, ID, client, manager: Cognito group `admin` only (not `super-admin` — naming is reversed vs typical) */
  const canEditProjectCoreFields = userGroups.includes('admin');

  const getSelectedProjectId = (id) => {
    if (masterProject.length > 0) {
      sessionStorage.setItem('activeId', id);
      var activeId = sessionStorage.getItem('activeId');
      setProjectId(parseInt(activeId));
      masterProject.map((data) => {
        if (data.id === id) {
          setSelectedProj(data);
          setStartDate(moment(data.startDate));
          setStartDateInput(moment(data.startDate));
          setDayShiftHour(data?.config?.technicalLogDefaultShiftHours?.day);
          setNightShiftHour(data?.config?.technicalLogDefaultShiftHours?.night);
          setDayShiftInputHour(data?.config?.technicalLogDefaultShiftHours?.day);
          setNightShiftInputHour(data?.config?.technicalLogDefaultShiftHours?.night);
          setSelectedStatus(data.projectStatus);
          setProjectStatus(data.projectStatus);
          if (data.endDate) {
            setEndDate(moment(data.endDate));
            setEndDateInput(moment(data.endDate));
          } else {
            setEndDate(null);
            setEndDateInput(null);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (projectList?.length !== 0) {
      setMasterProject(projectList);
      let completedCount = 0;
      let activeCount = 0;
      let facilityCount = 0;
      let initiatedCount = 0;
      let onHoldCount = 0;
      projectList.forEach((item) => {
        switch (item.projectStatus) {
          case 5:
            facilityCount++;
            break;
          case 4:
            completedCount++;
            break;
          case 2:
            activeCount++;
            break;
          case 1:
            initiatedCount++;
            break;
          default:
            onHoldCount++;
            break;
        }
      });
      setCompletedProject(completedCount);
      setFacilityProject(facilityCount);
      setActiveProject(activeCount);
      setInitiatedProject(initiatedCount);
      setOnHoldProject(onHoldCount);
      //
      setDataSource(projectList);
      var activeId = sessionStorage.getItem('activeId');
      if (activeId && projectList.length > 0) {
        const parsedId = parseInt(activeId, 10);
        var position = projectList.find((u) => u.id === parsedId);
        if (position?.id != null) {
          if (position.projectStatus === 2) {
            getSelectedProjectId(position.id);
          } else {
            sessionStorage.removeItem('activeId');
            const firstActive = projectList.find((p) => p.projectStatus === 2);
            const fallback = firstActive || position;
            if (fallback?.id != null) {
              getSelectedProjectId(fallback.id);
            }
          }
        } else {
          // Stale activeId (project removed or list changed): sync storage and select first row
          sessionStorage.removeItem('activeId');
          const firstActive = projectList.find((p) => p.projectStatus === 2);
          const first = firstActive || projectList[0];
          if (first?.id != null) {
            getSelectedProjectId(first.id);
          }
        }
      } else if (!activeId && projectList.length > 0) {
        const firstActive = projectList.find((p) => p.projectStatus === 2);
        const first = firstActive || projectList[0];
        if (first?.id != null) {
          getSelectedProjectId(first.id);
        }
      }
    }
  }, [projectList]);

  useEffect(() => {
    if (projectList?.length !== 0) {
      if (filterStatus > 0) {
        const filtered = projectList.filter((item) => item.projectStatus === filterStatus);
        setDataSource(filtered);
      } else {
        setDataSource(projectList);
      }
    }
  }, [filterStatus]);

  const resolveEditClientId = (record) => {
    if (!record) return undefined;
    const list = clientList || [];
    const raw = record.clientId;
    if (raw != null && raw !== '') {
      const byId = list.find((c) => c && (String(c.id) === String(raw) || c.id === raw));
      if (byId) return byId.id;
    }
    if (record.clientName) {
      const byName = list.find((c) => c && c.name === record.clientName);
      if (byName) return byName.id;
    }
    return undefined;
  };

  const parseModalDate = (d) => {
    if (d == null || d === '') return null;
    const strict = moment(d, 'MM-DD-YYYY', true);
    if (strict.isValid()) return strict;
    const loose = moment(d);
    return loose.isValid() ? loose : null;
  };

  const showModal = (record) => {
    setUpdateProjectId(record.id);
    if (record?.id) {
      const cfg = parseProjectConfig(record.config);
      const dayH = cfg.technicalLogDefaultShiftHours?.day;
      const nightH = cfg.technicalLogDefaultShiftHours?.night;
      const pt = record?.projectType || '';
      const showNdtReject = pt === 'Welding' || pt === 'Both';
      const startM = parseModalDate(record?.startDate);
      const endM = parseModalDate(record?.endDate);
      projectForm.setFieldsValue({
        editProjectName: record?.projectName ?? '',
        editProjectId: record?.projectId ?? '',
        editClientId: resolveEditClientId(record),
        manager: record?.manager || '',
        startDate: startM,
        endDate: endM,
        projectStatus: record?.projectStatus,
        completedWelds: '-',
        technicianLog: `${dayH ?? '0'} Hour / ${nightH ?? '0'} Hour`,
        editProjectName: record?.projectName || '',
        editProjectId: record?.projectId || '',
        editClientId: record?.clientId != null ? record.clientId : undefined,
        projectType: record?.projectType || '',
        ndtType: ndtTypeFormInitial(record),
        ndtRejectMaxPercent:
          showNdtReject && cfg.ndtRejectMaxPercent != null && cfg.ndtRejectMaxPercent !== ''
            ? Number(cfg.ndtRejectMaxPercent)
            : undefined,
        finalClient: record?.finalClient || '',
      });
      setSelectedStatus(record?.projectStatus ?? '');
      setStartDateInput(startM);
      setEndDateInput(endM);
      setDayShiftInputHour(dayH);
      setNightShiftInputHour(nightH);
      setProjectName(record?.projectName);
      setEditProjectType(record?.projectType || '');
      setEditNdtType(ndtTypeFormInitial(record));
      setEditFinalClient(record?.finalClient || '');
      setIsModalVisible(true);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    projectForm.resetFields();
    setEditProjectType('');
    setEditNdtType(undefined);
    setEditFinalClient('');
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    try {
      await projectForm.validateFields();
    } catch {
      return;
    }

    if (!updateProjectId) {
      notification.warn({ message: "Project ID is missing, can't update project." });
      return;
    }

    const formValues = projectForm.getFieldsValue();
    const currentProject = masterProject.find((p) => p.id === updateProjectId);
    const prevConfig = parseProjectConfig(currentProject?.config);
    const projectTypeVal = formValues.projectType ?? editProjectType ?? '';
    const weldingOrBoth =
      projectTypeVal === 'Welding' || projectTypeVal === 'Both';
    const ndtRejectRaw = formValues.ndtRejectMaxPercent;
    const ndtRejectNum =
      ndtRejectRaw !== undefined && ndtRejectRaw !== null && ndtRejectRaw !== ''
        ? Number(ndtRejectRaw)
        : undefined;

    const nextConfig = {
      ...prevConfig,
      technicalLogDefaultShiftHours: {
        day: dayShiftInputHour?.toString() || '',
        night: nightShiftInputHour?.toString() || '',
      },
    };
    if (
      weldingOrBoth &&
      ndtRejectNum !== undefined &&
      !Number.isNaN(ndtRejectNum)
    ) {
      nextConfig.ndtRejectMaxPercent = ndtRejectNum;
    } else {
      delete nextConfig.ndtRejectMaxPercent;
    }

    const updateData = {
      startDate: moment(formValues.startDate)?.format('MM-DD-YYYY'),
      endDate: moment(formValues.endDate)?.format('MM-DD-YYYY'),
      projectStatus: formValues.projectStatus,
      projectType: formValues.projectType ?? editProjectType ?? '',
      finalClient: formValues.finalClient ?? editFinalClient ?? '',
      ndtType:
        normalizeNdtTypeForApi(formValues.ndtType) ??
        normalizeNdtTypeForApi(editNdtType),
      config: nextConfig,
    };

    if (canEditProjectCoreFields) {
      updateData.projectName = formValues.editProjectName;
      updateData.projectId = formValues.editProjectId;
      updateData.clientId = formValues.editClientId;
      updateData.manager = formValues.manager;
    }

    onUpdateProject({ data: updateData, id: updateProjectId });
    setIsModalVisible(false);
  };

  const handleProjectClick = (event, data) => {
    if (event === 'project-clicked') {
      onProjectClick();
    }
  };

  const searchData = (e) => {
    const searchText = e.target.value.trim().toLowerCase();

    if (searchText.length > 0) {
      const filteredData = masterProject.filter(
        (value) =>
          value.projectName.toLowerCase().includes(searchText) ||
          value.projectId.toLowerCase().includes(searchText) ||
          value.location.toLowerCase().includes(searchText) ||
          value.manager.toLowerCase().includes(searchText) ||
          value.clientName.toLowerCase().includes(searchText)
      );

      if (filteredData.length > 0) {
        setDataSource(filteredData);
        setSelectedProj([]);
        setStartDate(null);
        setEndDate(null);
        setStartDateInput(null);
        setEndDateInput(null);
        setSelectedStatus('');
        setProjectStatus('');
        setSearchNotFound(false);
      } else {
        notification.warning({
          message: `No Project Found with "${searchText}"`,
        });
        setSearchNotFound(true);
        setText('');
        onSearch('');
      }
    } else {
      // Reset state when search text is cleared
      setDataSource(masterProject);
      setSelectedProj([]);
      setStartDate(null);
      setEndDate(null);
      setStartDateInput(null);
      setEndDateInput(null);
      setSelectedStatus('');
      setProjectStatus('');
      setSearchNotFound(false);
    }
  };

  const onSaveProject = async (data, client) => {
    try {
      if (data.endDate) {
        data.endDate = moment(data.endDate).format('MM-DD-YYYY');
      } else {
        data.endDate = null;
      }
      const resolvedClient =
        client && client.id
          ? client
          : (clientList || []).find((c) => c && c.name === data.clientName);
      if (!resolvedClient || !resolvedClient.id) {
        notification.warning({
          message: 'Please select a valid Client.',
        });
        return;
      }
      const finalClientTrimmed =
        data.finalClient != null && String(data.finalClient).trim() !== ''
          ? String(data.finalClient).trim()
          : undefined;
      const ptCreate = data.projectType ?? '';
      const weldingOrBothCreate =
        ptCreate === 'Welding' || ptCreate === 'Both';
      const ndtRejectRaw = data.ndtRejectMaxPercent;
      const ndtRejectNum =
        ndtRejectRaw !== undefined && ndtRejectRaw !== null && ndtRejectRaw !== ''
          ? Number(ndtRejectRaw)
          : undefined;
      const includeNdtRejectCreate =
        weldingOrBothCreate &&
        ndtRejectNum !== undefined &&
        !Number.isNaN(ndtRejectNum);
      var obj = {
        projectId: data.projectId,
        projectName: data.projectName,
        manager: data.manager,
        startDate: moment(data.startDate).format('MM-DD-YYYY'),
        endDate: data.endDate,
        contractId: data.contractId,
        pihRefId: data.pihRefId,
        contractor: data.contractor,
        location: data.location,
        projectType: data.projectType ?? '',
        clientId: resolvedClient.id,
        ...(finalClientTrimmed ? { finalClient: finalClientTrimmed } : {}),
        ...(normalizeNdtTypeForApi(data.ndtType) != null
          ? { ndtType: normalizeNdtTypeForApi(data.ndtType) }
          : {}),
        config: {
          technicalLogDefaultShiftHours: {
            day: String(data.dayShiftHour ?? 0),
            night: String(data.nightShiftHour ?? 0),
          },
          ...(includeNdtRejectCreate
            ? { ndtRejectMaxPercent: ndtRejectNum }
            : {}),
        },
        teamMember: data.teamMember,
      };
      await onSubmitProject({ data: obj, clientName: data.clientName });
    } catch (error) {
      console.error('Error saving project:', error);
    }
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    projectForm.setFieldsValue({ projectStatus: value });
  };

  const truncateTableData = useCallback((data) => {
    return (
      <Tooltip
        placement="topLeft"
        title={data}
      >
        {data}
      </Tooltip>
    );
  }, []);

  const handleColumnFilterChange = useCallback((key, value) => {
    setColumnFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const projectTableRows = useMemo(
    () =>
      (dataSource || []).map((row) => ({
        ...row,
        statusLabel: getStatusString(row.projectStatus),
      })),
    [dataSource]
  );

  const projectFacetRef = useRef([]);
  projectFacetRef.current = projectTableRows;
  const fetchProjectFacetRows = useCallback(async () => {
    const list = projectFacetRef.current;
    return Array.isArray(list) ? list : [];
  }, []);

  const searchCriteriaProjectFacets = useMemo(() => ({}), []);

  const { applyFacetClientFilter, renderTextColumnFilterTrigger } = useHeatStyleColumnFacets({
    enabled: true,
    filterableColumns: PROJECT_FACET_KEYS,
    listCount: projectTableRows.length,
    projectList: projectTableRows,
    searchCriteria: searchCriteriaProjectFacets,
    columnFilters,
    onColumnFilterChange: handleColumnFilterChange,
    fetchFacetRows: fetchProjectFacetRows,
  });

  const lc = (v) => (v == null ? '' : String(v)).trim().toLowerCase();
  const dateSearchBlob = (d) => {
    if (d == null || d === '') return '';
    const raw = String(d).toLowerCase();
    const m = moment(d);
    const fmt = m.isValid() ? m.format('DD MMM YYYY').toLowerCase() : '';
    return `${raw} ${fmt}`.trim();
  };

  const filteredAndFaceted = useMemo(() => {
    let list = [...projectTableRows];
    PROJECT_FACET_KEYS.forEach((key) => {
      const raw = (columnFilters[key] || '').trim();
      if (!raw) return;
      const q = lc(raw);
      list = list.filter((r) => {
        if (key === 'startDate' || key === 'endDate') {
          return dateSearchBlob(r[key]).includes(q);
        }
        if (key === 'projectId') {
          return lc(r.projectId).includes(q);
        }
        return lc(r[key]).includes(q);
      });
    });
    return applyFacetClientFilter(list);
  }, [projectTableRows, columnFilters, applyFacetClientFilter]);

  const handleSortClick = useCallback((field) => {
    setSortKey((prev) => {
      if (prev === field) {
        setSortDesc((d) => !d);
        return prev;
      }
      setSortDesc(false);
      return field;
    });
  }, []);

  const renderSortCaret = useCallback(
    (field) =>
      sortKey === field ? (
        sortDesc ? (
          <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        ) : (
          <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        )
      ) : (
        <CaretUpOutlined
          className="equipment-type-sort-dir-icon doc-control-sort-caret-inactive"
          aria-hidden
        />
      ),
    [sortKey, sortDesc]
  );

  const renderProjectColumnTitle = useCallback(
    (label, dataIndex, sortField, showFacet) => (
      <div className="column-header-with-filter">
        <div className="column-header-text-wrapper spares-column-header-sortable">
          <span>{label}</span>
          <span
            className="custom-sort-icon"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleSortClick(sortField);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSortClick(sortField);
              }
            }}
          >
            {renderSortCaret(sortField)}
          </span>
          {showFacet ? renderTextColumnFilterTrigger(dataIndex) : null}
        </div>
        <div className="header-filter-input user-mgmt-header-search">
          <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
            <Input
              placeholder="Search..."
              value={columnFilters[dataIndex] ?? ''}
              onChange={(e) => handleColumnFilterChange(dataIndex, e.target.value)}
              onClick={(e) => e.stopPropagation()}
              size="small"
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    ),
    [
      columnFilters,
      handleColumnFilterChange,
      handleSortClick,
      renderSortCaret,
      renderTextColumnFilterTrigger,
    ]
  );

  const sortedList = useMemo(() => {
    const list = [...filteredAndFaceted];
    list.sort((a, b) => {
      let cmp = 0;
      switch (sortKey) {
        case 'projectName':
          cmp = (a.projectName || '').localeCompare(b.projectName || '', undefined, {
            sensitivity: 'base',
          });
          break;
        case 'statusLabel':
          cmp = (a.statusLabel || '').localeCompare(b.statusLabel || '', undefined, {
            sensitivity: 'base',
          });
          break;
        case 'location':
          cmp = (a.location || '').localeCompare(b.location || '', undefined, { sensitivity: 'base' });
          break;
        case 'projectType':
          cmp = String(a.projectType || '').localeCompare(String(b.projectType || ''), undefined, {
            sensitivity: 'base',
          });
          break;
        case 'projectId':
          cmp = String(a.projectId || '').localeCompare(String(b.projectId || ''), undefined, {
            numeric: true,
            sensitivity: 'base',
          });
          break;
        case 'clientName':
          cmp = (a.clientName || '').localeCompare(b.clientName || '', undefined, { sensitivity: 'base' });
          break;
        case 'manager':
          cmp = (a.manager || '').localeCompare(b.manager || '', undefined, { sensitivity: 'base' });
          break;
        case 'startDate': {
          const va = moment(a.startDate).valueOf();
          const vb = moment(b.startDate).valueOf();
          cmp = (Number.isNaN(va) ? 0 : va) - (Number.isNaN(vb) ? 0 : vb);
          break;
        }
        case 'endDate': {
          const va = moment(a.endDate).valueOf();
          const vb = moment(b.endDate).valueOf();
          cmp = (Number.isNaN(va) ? 0 : va) - (Number.isNaN(vb) ? 0 : vb);
          break;
        }
        default:
          cmp = 0;
      }
      return sortDesc ? -cmp : cmp;
    });
    return list;
  }, [filteredAndFaceted, sortKey, sortDesc]);

  const tableColumns = useMemo(
    () => [
      {
        title: renderProjectColumnTitle('PROJECT NAME', 'projectName', 'projectName', true),
        dataIndex: 'projectName',
        key: 'projectName',
        ellipsis: {
          showTitle: true,
        },
        width: '15%',
        render: (text, record) => {
          const status = getStatusString(record.projectStatus);
          let avatarColor;

          switch (status) {
            case 'Completed':
              avatarColor = 'green';
              break;
            case 'Active':
              avatarColor = 'orange';
              break;
            case 'OnHold':
              avatarColor = '#00A6ED';
              break;
            case 'Initiated':
              avatarColor = '#1F305E';
              break;
            case 'Facility':
              avatarColor = 'pink';
              break;
            default:
              avatarColor = 'default';
          }

          const initial = text && String(text).length ? text[0] : '?';

          return (
            <div>
              <Avatar style={{ marginRight: 8, backgroundColor: avatarColor }}>{initial}</Avatar>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{truncateTableData(text)}</span>
            </div>
          );
        },
      },
      {
        title: renderProjectColumnTitle('STATUS', 'statusLabel', 'statusLabel', true),
        dataIndex: 'projectStatus',
        key: 'projectStatus',
        render: (status) => {
          const label = getStatusString(status);
          return (
            <div>
              <Tag
                className="project-status"
                color={statusColors[label]}
              >
                {label}
              </Tag>
            </div>
          );
        },
      },
      {
        title: renderProjectColumnTitle('LOCATION', 'location', 'location', true),
        dataIndex: 'location',
        key: 'location',
        render: (text) => (
          <div>
            <strong>{text}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('PROJECT TYPE', 'projectType', 'projectType', true),
        dataIndex: 'projectType',
        key: 'projectType',
        render: (text) => (
          <div>
            <strong>{text || '-'}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('PROJECT ID', 'projectId', 'projectId', true),
        dataIndex: 'projectId',
        key: 'projectId',
        render: (text) => (
          <div>
            <strong>{text}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('CLIENT NAME', 'clientName', 'clientName', true),
        dataIndex: 'clientName',
        key: 'clientName',
        render: (text) => (
          <div>
            <strong>{text}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('MANAGER', 'manager', 'manager', true),
        dataIndex: 'manager',
        key: 'manager',
        render: (text) => (
          <div>
            <strong>{text}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('START DATE', 'startDate', 'startDate', true),
        dataIndex: 'startDate',
        key: 'startDate',
        render: (text) => (
          <div>
            <strong> {text ? moment(text).format('DD MMM YYYY') : '-'}</strong>
          </div>
        ),
      },
      {
        title: renderProjectColumnTitle('END DATE', 'endDate', 'endDate', true),
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text) => (
          <div>
            <strong>{text ? moment(text).format('DD MMM YYYY') : '-'}</strong>
          </div>
        ),
      },
      {
        title: <span className="equipment-type-column-title">ACTIONS</span>,
        key: 'action',
        dataIndex: 'action',
        width: '90px',
        render: (text, record) => {
          return (
            <div>
              <Tooltip title="Update">
                <span className="icon-18 mr-2 cursor-pointer edit-hover">
                  <EditOutlined
                    style={{ fontSize: '18px' }}
                    onClick={() => {
                      showModal(record);
                    }}
                  />
                </span>
              </Tooltip>
            </div>
          );
        },
        align: 'center',
      },
    ],
    [renderProjectColumnTitle, truncateTableData]
  );

  const handleRowClick = (record) => {
    getSelectedProjectId(record.id);
    handleProjectClick('project-clicked');
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        // Check if the click target is within the "Actions" column
        if (!event.target.closest('.ant-table-cell:last-child')) {
          handleRowClick(record);
        }
      },
    };
  };

  return (
    <div className="projects-dashboard">
      <div className="filters">
        <div className="d-flex project-search">
          <div className="peoject-header">
            <h2>Projects</h2>
          </div>
          <div className="search">
            <Input
              placeholder="Search"
              onChange={searchData}
            />
          </div>
        </div>
        <div className="project-stats">
          <div
            className={`stat-item ${filterStatus === 0 ? 'active' : ''}`}
            onClick={() => setFilterStatus(0)}
          >
            <span className="stat-icon">📊</span>
            <span className="stat-label">Total Projects:</span>
            <span className="stat-value total-stat">{projectList.length}</span>
          </div>
          <div
            className={`stat-item ${filterStatus === 2 ? 'active' : ''}`}
            onClick={() => setFilterStatus(2)}
          >
            <span
              className="stat-icon"
              style={{ color: 'orange' }}
            >
              🔥
            </span>
            <span className="stat-label">Active:</span>
            <span
              className="stat-value"
              style={{ color: 'orange' }}
            >
              {activeProject}
            </span>
          </div>
          <div
            className={`stat-item ${filterStatus === 1 ? 'active' : ''}`}
            onClick={() => setFilterStatus(1)}
          >
            <span
              className="stat-icon"
              style={{ color: 'blue' }}
            >
              🚀
            </span>
            <span className="stat-label">Initiated:</span>
            <span
              className="stat-value"
              style={{ color: '#0d47a1' }}
            >
              {initiatedProject}
            </span>
          </div>

          <div
            className={`stat-item ${filterStatus === 5 ? 'active' : ''}`}
            onClick={() => setFilterStatus(5)}
          >
            <span
              className="stat-icon"
              style={{ color: '#708090' }}
            >
              🏢
            </span>
            <span className="stat-label">Facility:</span>
            <span
              className="stat-value"
              style={{ color: '#708090' }}
            >
              {facilityProject}
            </span>
          </div>
          <div
            className={`stat-item ${filterStatus === 3 ? 'active' : ''}`}
            onClick={() => setFilterStatus(3)}
          >
            <span
              className="stat-icon"
              style={{ color: '#00E3FF' }}
            >
              ⏸️
            </span>
            <span className="stat-label">On Hold:</span>
            <span
              className="stat-value"
              style={{ color: '#00A6ED' }}
            >
              {onHoldProject}
            </span>
          </div>
          <div
            className={`stat-item ${filterStatus === 4 ? 'active' : ''}`}
            onClick={() => setFilterStatus(4)}
          >
            <span
              className="stat-icon"
              style={{ color: 'green' }}
            >
              ✅
            </span>
            <span className="stat-label">Completed:</span>
            <span
              className="stat-value"
              style={{ color: '#00D26A' }}
            >
              {completedProject}
            </span>
          </div>
          <div>
            <CreateProject
              projectForm={projectForm}
              onSaveProject={onSaveProject}
              clientList={clientList}
            />
          </div>
        </div>
      </div>

      <Table
        columns={tableColumns}
        dataSource={sortedList}
        onRow={onRow}
        className="dashBoard-table heat-profile-table pipeline-table equipment-types-table"
        scroll={{ y: 'calc(100vh - 170px)', x: 1200 }}
        pagination={false}
      />

      <Modal
        width="50vw"
        className="pipeline-modal"
        title={`Project :- ${projectName || ''}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={isSaving}
            onClick={handleSave}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </Button>,
        ]}
      >
        <Form
          form={projectForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label="Project Name"
                name="editProjectName"
                rules={
                  canEditProjectCoreFields
                    ? [{ required: true, message: 'Please enter project name' }]
                    : []
                }
              >
                <Input
                  placeholder="Enter Project Name"
                  size="large"
                  disabled={!canEditProjectCoreFields}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Project ID"
                name="editProjectId"
                rules={
                  canEditProjectCoreFields
                    ? [{ required: true, message: 'Please enter project ID' }]
                    : []
                }
              >
                <Input
                  placeholder="Enter Project ID"
                  size="large"
                  disabled={!canEditProjectCoreFields}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Client"
                name="editClientId"
                rules={
                  canEditProjectCoreFields
                    ? [{ required: true, message: 'Please select a client' }]
                    : []
                }
              >
                <Select
                  className="client-select"
                  placeholder="Select client"
                  disabled={!canEditProjectCoreFields}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {(clientList || []).map((item) => (
                    <Option
                      key={item.id}
                      value={item.id}
                    >
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Manager"
                name="manager"
                rules={
                  canEditProjectCoreFields
                    ? [{ required: true, message: 'Please enter manager name' }]
                    : []
                }
              >
                <Input
                  placeholder="Enter Manager Name"
                  size="large"
                  disabled={!canEditProjectCoreFields}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="date-picker"
                label="Start Date"
                name="startDate"
              >
                <DatePicker
                  allowClear={false}
                  format="DD-MM-YYYY"
                  defaultValue={startDateInput}
                  onChange={(date) => setStartDateInput(date)}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="date-picker"
                label="End Date"
                name="endDate"
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  allowClear={false}
                  defaultValue={endDateInput}
                  onChange={(date) => setEndDateInput(date)}
                  disabledDate={(current) =>
                    startDateInput && current < moment(startDateInput, 'DD-MM-YYYY')
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Project Status"
                name="projectStatus"
              >
                <Select
                  className="client-select"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                >
                  <Option value={1}>Initiated</Option>
                  <Option value={2}>Active</Option>
                  <Option value={3}>On Hold</Option>
                  <Option value={4}>Completed</Option>
                  <Option value={5}>Facility</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Completed Welds"
                name="completedWelds"
                initialValue="-"
              >
                <Input
                  placeholder="Completed Welds"
                  size="large"
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Technician Log Default Day/Night Shift"
                name="technicianLog"
              >
                <Input
                  value={`${dayShiftInputHour} Hour / ${nightShiftInputHour} Hour`}
                  size="large"
                  onChange={(e) => {
                    const [day, night] = e.target.value.split(' / ').map((val) => parseInt(val));
                    setDayShiftInputHour(day);
                    setNightShiftInputHour(night);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Project Type" name="projectType">
                <Select
                  className="client-select"
                  placeholder="Select project type"
                  value={editProjectType || undefined}
                  onChange={(v) => setEditProjectType(v)}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    String(option?.children ?? '')
                      .toLowerCase()
                      .includes(String(input).toLowerCase())
                  }
                >
                  <Option value="Welding">Welding</Option>
                  <Option value="Coating">Coating</Option>
                  <Option value="Both">Both</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="NDT Type" name="ndtType">
                <ModernMultiCheckboxSelect
                  value={editNdtType || undefined}
                  onChange={(v) => setEditNdtType(v)}
                  options={NDT_PIPELINE_TYPE_OPTIONS}
                  placeholder="Select NDT type(s)"
                />
              </Form.Item>
            </Col>
            {(editProjectType === 'Welding' || editProjectType === 'Both') && (
              <Col span={8}>
                <Form.Item
                  label="Max NDT reject % (client limit)"
                  name="ndtRejectMaxPercent"
                  tooltip="NDT rejects must stay at or below this percentage per client specification."
                >
                  <InputNumber
                    min={0}
                    max={100}
                    step={0.1}
                    placeholder="e.g. 2"
                    style={{ width: '100%' }}
                    size="large"
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={8}>
              <Form.Item label="Final Client" name="finalClient">
                <Select
                  className="client-select"
                  placeholder="Select Final Client"
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  value={editFinalClient || undefined}
                  onChange={(v) => setEditFinalClient(v)}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {(clientList || []).map((item, i) => (
                    <Option key={i} value={item && item.name}>
                      {item && item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
ProjectDashboard.propTypes = {
  onSubmitProject: func.isRequired,
  onUpdateProject: func.isRequired,
};

const mapDispatchToProps = {
  onSubmitProject: submitProject,
  onUpdateProject: updateProject,
};

export default connect(null, mapDispatchToProps)(ProjectDashboard);
